/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_h as h,
} from "../../runtime/index.jsx";
export function AvatarPersona(e) {
  let t = (0, ReactCompiler.c)(14),
    { anclaRef: n, className: r, anchoMinimo: i, children: a } = e,
    o = r === void 0 ? `` : r,
    s = i === void 0 ? 0 : i,
    [c, l] = (0, React.useState)(null),
    u = (0, React.useRef)(null),
    f,
    p;
  if (
    (t[0] !== s || t[1] !== n
      ? ((f = () => {
          let e = function () {
            let e = n?.current;
            if (!e) return;
            let t = e.getBoundingClientRect(),
              r = window.innerHeight - t.bottom - 8,
              i = t.top - 8,
              a = r < 220 && i > r,
              o = Math.max(t.width, s);
            l({
              left: Math.max(8, Math.min(t.left, window.innerWidth - o - 8)),
              width: o,
              top: a ? void 0 : t.bottom + 4,
              bottom: a ? window.innerHeight - t.top + 4 : void 0,
              maxHeight: Math.max(160, a ? i : r),
            });
          };
          return (
            e(),
            window.addEventListener(`scroll`, e, !0),
            window.addEventListener(`resize`, e),
            () => {
              (window.removeEventListener(`scroll`, e, !0),
                window.removeEventListener(`resize`, e));
            }
          );
        }),
        (p = [n, s]),
        (t[0] = s),
        (t[1] = n),
        (t[2] = f),
        (t[3] = p))
      : ((f = t[2]), (p = t[3])),
    (0, React.useLayoutEffect)(f, p),
    !c)
  )
    return null;
  let m;
  t[4] !== c.bottom ||
  t[5] !== c.left ||
  t[6] !== c.maxHeight ||
  t[7] !== c.top ||
  t[8] !== c.width
    ? ((m = {
        position: `fixed`,
        left: c.left,
        width: c.width,
        top: c.top,
        bottom: c.bottom,
        maxHeight: c.maxHeight,
      }),
      (t[4] = c.bottom),
      (t[5] = c.left),
      (t[6] = c.maxHeight),
      (t[7] = c.top),
      (t[8] = c.width),
      (t[9] = m))
    : (m = t[9]);
  let _ = `animar-entrada z-[60] overflow-y-auto ${o}`,
    v;
  return (
    t[10] !== a || t[11] !== m || t[12] !== _
      ? ((v = (0, h.createPortal)(
          <div
            ref={u}
            data-flotante={`true`}
            style={m}
            className={_}
            children={a}
          />,
          document.body,
        )),
        (t[10] = a),
        (t[11] = m),
        (t[12] = _),
        (t[13] = v))
      : (v = t[13]),
    v
  );
}
